/**
 * Single source of truth for the responsive nav chrome's pixel dimensions.
 *
 * `MainSidebar` renders all three presentations with `position: fixed`, so
 * any scene that mounts it (today: `HomeScene`) must reserve matching space
 * on the main content area via padding. Centralizing the values here lets
 * the sidebar components and the consuming scene agree at compile time —
 * change a number once, all four call sites update together.
 *
 * Consumers:
 * - `MainSidebar.tsx` → desktop fixed sidebar width
 * - `IconRailSidebar.tsx` → tablet icon-rail width
 * - `MobileTopBar.tsx` → mobile top-bar height
 * - `scenes/HomeScene.tsx` → responsive content padding (via injected CSS vars)
 */

/** Width of the full desktop sidebar, in pixels. Applied at the `lg` breakpoint and up. */
export const MAIN_SIDEBAR_WIDTH_PX = 260;

/** Width of the collapsed tablet icon rail, in pixels. Applied at the `md` breakpoint only. */
export const ICON_RAIL_WIDTH_PX = 64;

/** Height of the mobile top bar, in pixels. Shown below the `md` breakpoint. */
export const MOBILE_TOP_BAR_HEIGHT_PX = 56;
